module.exports = __webpack_public_path__ + "img/back.1ddab6fc.svg";